<template>
    <b-container class="container-panel">
        <AmbitLogo></AmbitLogo>
        <LanguageSelection></LanguageSelection>
        <PaymentPlanReview v-if="canRead" v-show="isReview" :key="componentKey" :permissions="permissions" @enroll="showEnroll" :user="user" :depositInfo="depositInfo" @close="showReview"></PaymentPlanReview>
        <PaymentPlanEnroll v-show="isEnroll" :key="componentKey + 1" :permissions="permissions" :depositInfo="depositInfo" @pay="showPay"></PaymentPlanEnroll>
        <PaymentPlanPay v-show="isPay" :key="componentKey + 2" :createPaymentPlanRequest="createPaymentPlanRequest" :permissions="permissions" :user="user" :depositInfo="depositInfo" @close="showReview"></PaymentPlanPay>
    </b-container>
</template>

<script>
    import AmbitLogo from '../components/AmbitLogo.vue';
    import Email from '../components/Email.vue';
    import LanguageSelection from '../components/LanguageSelection.vue';
    import Repo from '../repo';
    import i18n from '../localization';
    import { mapGetters } from 'vuex';
    import PaymentPlanReview from '../components/PaymentPlanReview.vue';
    import PaymentPlanEnroll from '../components/PaymentPlanEnroll.vue';
    import PaymentPlanPay from '../components/PaymentPlanPay.vue';
    export default {
        name: "PaymentPlan",
        components: { AmbitLogo, Email, LanguageSelection, PaymentPlanReview, PaymentPlanEnroll, PaymentPlanPay },
        data() {
            return {
                componentKey: 0,
                isReview: true,
                isEnroll: false,
                isPay: false,
                createPaymentPlanRequest: {},
                permissions: [],
                user: "",
                canRead: false,
                depositInfo: {
                    hasDeposit: false,
                    depositAmount: 0,
                    depositMessage: "",
                }
            }
        },
        mounted: async function () {
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            Repo.AuthenticationService.ValidateToken({ Token: this.$route.params.authToken }).then(res => {
                if (res && res.success) {
                    this.getPermissions();
                    this.user = res.userId;
                } else if (window.location.href.includes("localhost")) {
                } else {
                    this.$store.dispatch('shell/addErrorMessages', i18n.t('NOT_AUTHENTICATED'));
                    this.$router.push('/');
                }
            });
            this.checkCanRead();
            await this.getDepositInformationForDeferredPaymentPlan(this.$route.params.customerNumber);
        },
        methods: {
            showEnroll(value) {
                this.isReview = false;
                this.isEnroll = true;
                this.isPay = false;
                return;
            },
            showPay(value) {
                this.createPaymentPlanRequest = value;
                this.isReview = false;
                this.isEnroll = false;
                this.isPay = true;
                return;
            },
            showReview(value) {
                this.forceRerender();
                this.isReview = true;
                this.isEnroll = false;
                this.isPay = false;
                return;
            },
            forceRerender() {
                this.componentKey += 3;
            },
            getPermissions: async function () {
                let res = await Repo.PermissionsService.GetPermissionsObjects({ token: this.$route.params.authToken });
                this.permissions = res;
                return;
            },
            checkCanRead() {
                if (this.permissions.includes(105018)) {
                    this.canRead = true;
                }
                return;
            },
            getDepositInformationForDeferredPaymentPlan(customerNbr) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetDepositInformationForDeferredPaymentPlan({
                        customerNbr: customerNbr
                    }).then(res => {
                        console.log('log 1')
                        console.log(res);
                        this.depositInfo.hasDeposit = res.hasDeposit;
                        this.depositInfo.depositAmount = res.depositAmount;
                        this.depositInfo.depositMessage = res.depositMessage;
                        console.log(this.depositInfo);
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        this.forceRerender();
                        resolve(true);
                    });
                });
            },
        },
        computed: {            
        },
        watch: {
            permissions: function (newVal, oldVal) {
                this.checkCanRead();
            },

        }
    }
</script>
